var moduleMap = {
	"./UnitySharedAdminManagement": () => {
		return Promise.all([__webpack_require__.e(956), __webpack_require__.e(912), __webpack_require__.e(533), __webpack_require__.e(107), __webpack_require__.e(297), __webpack_require__.e(857), __webpack_require__.e(569), __webpack_require__.e(69), __webpack_require__.e(92), __webpack_require__.e(554), __webpack_require__.e(368), __webpack_require__.e(177)]).then(() => (() => ((__webpack_require__(30488)))));
	},
	"./UserAnnouncements": () => {
		return Promise.all([__webpack_require__.e(956), __webpack_require__.e(912), __webpack_require__.e(107), __webpack_require__.e(297), __webpack_require__.e(569), __webpack_require__.e(69), __webpack_require__.e(92), __webpack_require__.e(368), __webpack_require__.e(83)]).then(() => (() => ((__webpack_require__(28083)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});